import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Footer } from '../components/Footer';
import { useTranslation } from '../lib/i18n';
export function Impressum() {
  const {
    t
  } = useTranslation();
  return <HelmetProvider data-id="element-233">
      <div className="min-h-screen bg-background text-text-primary font-sans flex flex-col" data-id="element-234">
        <Helmet data-id="element-235">
          <title data-id="element-236">Impressum | Caro Loesel</title>
          <meta name="robots" content="noindex, nofollow" data-id="element-237" />
        </Helmet>

        <main className="flex-grow container mx-auto px-4 py-12 md:py-20 max-w-3xl" data-id="element-238">
          <Link to="/" className="inline-flex items-center text-hotpink hover:text-hotpink/80 transition-colors mb-8 font-medium" data-id="element-239">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-240" />
            {t.legal.backToHome}
          </Link>

          <h1 className="text-3xl md:text-4xl font-heading font-bold text-text-primary mb-8" data-id="element-241">
            Impressum
          </h1>

          <div className="space-y-8 text-text-secondary leading-relaxed" data-id="element-242">
            <section data-id="element-243">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-244">
                Angaben gemäß § 5 TMG
              </h2>
              <p data-id="element-245">
                EXXOTIC Management UG
                <br data-id="element-246" />
                Äußere Bayreuther Str. 59
                <br data-id="element-247" />
                90409 Nürnberg
                <br data-id="element-248" />
                Deutschland
              </p>
            </section>

            <section data-id="element-249">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-250">
                Kontakt
              </h2>
              <p data-id="element-251">
                E-Mail: info@exxotic-management.com
                <br data-id="element-252" />
                Webseite: www.caroloesel.com
              </p>
            </section>

            <section data-id="element-253">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-254">
                Registereintrag
              </h2>
              <p data-id="element-255">
                Eintragung im Handelsregister.
                <br data-id="element-256" />
                Registergericht: Amtsgericht Nürnberg
                <br data-id="element-257" />
                Registernummer: HRB 41546
              </p>
            </section>

            <section data-id="element-258">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-259">
                Umsatzsteuer-ID
              </h2>
              <p data-id="element-260">
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a
                Umsatzsteuergesetz:
                <br data-id="element-261" />
                DE419617625
              </p>
            </section>

            <section data-id="element-262">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-263">
                Steuernummer
              </h2>
              <p data-id="element-264">241/125/92853</p>
            </section>

            <section data-id="element-265">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-266">
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <p data-id="element-267">
                EXXOTIC Management UG
                <br data-id="element-268" />
                Äußere Bayreuther Str. 59
                <br data-id="element-269" />
                90409 Nürnberg
              </p>
            </section>

            <section data-id="element-270">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-271">
                Haftungsausschluss
              </h2>
              <p className="mb-4" data-id="element-272">
                <strong data-id="element-273">Haftung für Inhalte</strong>
                <br data-id="element-274" />
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
                Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
                gespeicherte fremde Informationen zu überwachen oder nach
                Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
                hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
                Nutzung von Informationen nach den allgemeinen Gesetzen bleiben
                hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst
                ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
                möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen
                werden wir diese Inhalte umgehend entfernen.
              </p>
              <p data-id="element-275">
                <strong data-id="element-276">Haftung für Links</strong>
                <br data-id="element-277" />
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf
                deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
                diese fremden Inhalte auch keine Gewähr übernehmen. Für die
                Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
                oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
                wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
                überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
                Verlinkung nicht erkennbar. Eine permanente inhaltliche
                Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
                Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
                Bekanntwerden von Rechtsverletzungen werden wir derartige Links
                umgehend entfernen.
              </p>
            </section>
          </div>
        </main>

        <Footer data-id="element-278" />
      </div>
    </HelmetProvider>;
}